import React, {Fragment, useEffect, useRef} from "react";
import {Layers} from "./Layers";

export function LayerImageUrl(currentGroup, group, cake, config) {
    const active = currentGroup === group;

    if (!cake[group]) { return false; }

    let url = config.items[cake[group]].image;
    if (active && config.items[cake[group]].image_active) {
        url = config.items[cake[group]].image_active;
    }

    if (url === false) {
        return false;
    }
    return Layers.reduce((url, group) => {
        if (cake[group]) {
            return url.replace(`{${group}}`, cake[group]);
        }
        return url;
    }, url);
}

function LayerImage({currentGroup, group, cake, config}) {
    const url = LayerImageUrl(currentGroup, group, cake, config);
    if (url === false) {
        return null;
    }

    return <image key={'layer-' + group} data-group={group} xlinkHref={url} x="0" y="0" height="300px" width="400px" />;
}

export function ShowWhenSet(group, cake, config, currentGroup) {
    return cake[group];
}

export function ShowWhenActive(group, cake, config, currentGroup) {
    return cake[group] && currentGroup === group;
}

function ShowFlavor(group, cake, config, currentGroup) {
    return cake[group] && (
        currentGroup === group ||
        currentGroup === 'size'
    );
}

function ShowCustomizer(group, cake, config, currentGroup) {
    const customizer = cake.customizer;
    const size = cake.size;
    const decor = cake.decor;

    return customizer && size && decor;
}

function DecorImage({group, cake, config, currentGroup}) {
    return <Fragment>
        <image key={'layer-' + group} data-group={group} xlinkHref={LayerImageUrl(currentGroup, group, cake, config)} x="0" y="0" height="300px" width="400px" />
    </Fragment>;
}


const LayerImageOrder = [
    ['finish', LayerImage, ShowWhenSet],
    ['size', LayerImage, ShowWhenSet],
    ['decor', DecorImage, ShowWhenSet],
    ['customizer', HgCakeCustomization, ShowCustomizer],
    ['flavor', LayerImage, ShowWhenActive],
];

const customImageSizes = {
    '14cm': {
        'text': {
            x: 140,
            y: 45,
            width: 120,
            height: 120
        },
        'image': {
            x: 125,
            y: 30,
            width: 150,
            height: 150
        }
    },

    '22cm': {
        'text': {
            x: 125,
            y: 30,
            width: 150,
            height: 150
        },
        'image': {
            x: 85,
            y: -5,
            width: 230,
            height: 230
        }
    },

    '30cm': {
        'text': {
            x: 105,
            y: 0,
            width: 190,
            height: 190
        },
        'image': {
            x: 46,
            y: -45,
            width: 305,
            height: 305
        }
    }
};

const clipPathSizes = {
    '14cm': {
        'text': {
            cx: 200,
            cy: 105,
            r: 56
        },
        'image': {
            cx: 200,
            cy: 105,
            r: 75
        }
    },
    '22cm': {
        'text': {
            cx: 200,
            cy: 105,
            r: 75
        },
        'image': {
            cx: 200,
            cy: 105,
            r: 115
        }
    },
    '30cm': {
        'text': {
            cx: 200,
            cy: 85,
            r: 90
        },
        'image': {
            cx: 200,
            cy: 85,
            r: 152
        }
    }
}

function HgCustomImageProps(src, cakeSize, waferSize) {
    if (waferSize === "imagesmall") {
        waferSize = "text";
    }

    if (src.hasOwnProperty(cakeSize)) {
        if (src[cakeSize].hasOwnProperty(waferSize)) {
            return src[cakeSize][waferSize];
        }
    }
    return null;
}

function HgCakeCustomization({group, cake, config}) {
    const customizer = cake.customizer;
    const size = cake.size;
    const decor = cake.decor;

    if (!customizer || !size || !decor) { return false; }

    const imageProps    = HgCustomImageProps(customImageSizes, size, decor);
    const clipPathProps = HgCustomImageProps(clipPathSizes, size, decor);

    if (!imageProps) {
        return null;
    }

    const style = {
        '14cm': {
            transform: 'rotateX(70deg) translateY(205px)'
        },
        '22cm': {
            transform: 'rotateX(70deg) translateY(205px)'
        },
        '30cm': {
            transform: 'rotateX(66deg) translateY(182px)'
        }
    }
    const isText = cake.customizer.type === 'text';
    const isImage = cake.customizer.type === 'image';
    let textParts = [];

    if (isText) {
        textParts = cake.customizer.text.split(/\n/).map((line, idx) => {
            return <tspan key={"tspan" + idx} dy={idx + 'em'} x="200">{line}</tspan>;
        });
    }

    return <Fragment>
        <defs>
            <clipPath id={"customizer"}>
                <circle {...clipPathProps} />
            </clipPath>
        </defs>
        <g clipPath={"url(#customizer)"} style={style[size]}>
            {isImage && <image preserveAspectRatio={"none"} {...imageProps} xlinkHref={cake.customizer.image}/>}
            {isText && <Fragment>
                <text y="95" textAnchor="middle" alignmentBaseline="central" x="200">
                    {textParts}
                </text>
            </Fragment>}
        </g>
    </Fragment>;
}

export default function HgCakeDisplay({cake, config, currentGroup}) {


    return <Fragment>
        <div className={"hg-cake-editor-display"}>
            <div className={"hg-cake-editor-display__inner"}>
                <svg viewBox={"0 0 400 300"}>
                    {LayerImageOrder.map(([group, C, filter], idx) => {
                        if (filter(group, cake, config, currentGroup)) {
                            return <C key={group + '_' + idx} group={group} cake={cake} config={config} currentGroup={currentGroup} />;
                        }
                        return null;
                    })}
                </svg>
            </div>
        </div>
    </Fragment>;
}


// WEBPACK FOOTER //
// ./js/cake/HgCakeDisplay.js